import React, { createContext, ReactNode } from 'react';
import NotFind from '../components/customLayout/notfind';
import Gender from '../components/customLayout/gender';
import Dialog from '../components/customLayout/dialog';

const GlobalComponentsContext = createContext({ NotFind, Gender, Dialog });

interface GlobalComponentsProviderProps {
  children: ReactNode;
}

export const GlobalComponentsProvider: React.FC<
  GlobalComponentsProviderProps
> = ({ children }) => {
  return (
    <GlobalComponentsContext.Provider value={{ NotFind, Gender, Dialog }}>
      {children}
    </GlobalComponentsContext.Provider>
  );
};
